export const countryCodeslist = [
  { id: 1, code: "+1", name: "USA" },
  { id: 2, code: "+971", name: "UAE" },
  { id: 3, code: "+86", name: "CHN" },
  { id: 4, code: "+91", name: "IND" },
  { id: 5, code: "+7", name: "RUS" },
  { id: 6, code: "+81", name: "JPN" },
  { id: 7, code: "+49", name: "DEU" },
  { id: 8, code: "+44", name: "GBR" },
  { id: 9, code: "+33", name: "FRA" },
  { id: 10, code: "+39", name: "ITA" },
  { id: 11, code: "+55", name: "BRA" },
  { id: 12, code: "+34", name: "ESP" },
  { id: 13, code: "+61", name: "AUS" },
  { id: 14, code: "+52", name: "MEX" },
  { id: 15, code: "+82", name: "KOR" },
  { id: 16, code: "+90", name: "TUR" },
  { id: 17, code: "+62", name: "IDN" },
  { id: 18, code: "+27", name: "ZAF" },
  { id: 19, code: "+92", name: "PAK" },
  { id: 20, code: "+31", name: "NLD" },
  { id: 21, code: "+880", name: "BGD" },
  { id: 23, code: "+63", name: "PHL" },
  { id: 24, code: "+20", name: "EGY" },
  { id: 25, code: "+46", name: "SWE" },
  { id: 26, code: "+886", name: "TWN" },
  { id: 27, code: "+30", name: "GRC" },
  { id: 28, code: "+65", name: "SGP" },
  { id: 29, code: "+60", name: "MYS" },
  { id: 30, code: "+57", name: "COL" },
  { id: 31, code: "+41", name: "CHE" },
  { id: 32, code: "+358", name: "FIN" },
  { id: 33, code: "+66", name: "THA" },
  { id: 34, code: "+32", name: "BEL" },
  { id: 35, code: "+45", name: "DNK" },
  { id: 36, code: "+47", name: "NOR" },
  { id: 37, code: "+972", name: "ISR" },
  { id: 38, code: "+48", name: "POL" },
  { id: 39, code: "+966", name: "SAU" },
  { id: 40, code: "+420", name: "CZE" },
  { id: 41, code: "+98", name: "IRN" },
  { id: 42, code: "+351", name: "PRT" },
  { id: 43, code: "+372", name: "EST" },
  { id: 44, code: "+36", name: "HUN" },
  { id: 45, code: "+40", name: "ROU" },
  { id: 46, code: "+263", name: "ZWE" },
  { id: 47, code: "+357", name: "CYP" },
  { id: 48, code: "+504", name: "HND" },
  { id: 49, code: "+507", name: "PAN" },
  { id: 50, code: "+592", name: "GUY" },
  { id: 51, code: "+222", name: "MRT" },
  { id: 52, code: "+678", name: "VUT" },
  { id: 53, code: "+232", name: "SLE" },
  { id: 54, code: "+352", name: "LUX" },
  { id: 55, code: "+961", name: "LBN" },
  { id: 56, code: "+685", name: "WSM" },
  { id: 57, code: "+269", name: "COM" },
  { id: 58, code: "+299", name: "GRL" },
  { id: 59, code: "+968", name: "OMN" },
  { id: 60, code: "+381", name: "SRB" },
  { id: 61, code: "+378", name: "SMR" },
  { id: 62, code: "+595", name: "PRY" },
  { id: 63, code: "+297", name: "ABW" },
  { id: 64, code: "+371", name: "LVA" },
  { id: 65, code: "+506", name: "CRI" },
  { id: 66, code: "+370", name: "LTU" },
  { id: 67, code: "+967", name: "YEM" },
  { id: 68, code: "+250", name: "RWA" },
  { id: 69, code: "+853", name: "MAC" },
  { id: 70, code: "+220", name: "GMB" },
  { id: 71, code: "+679", name: "FJI" },
  { id: 72, code: "+223", name: "MLI" },
  { id: 73, code: "+970", name: "PSE" },
  { id: 74, code: "+850", name: "PRK" },
  { id: 75, code: "+960", name: "MDV" },
  { id: 76, code: "+675", name: "PNG" },
  { id: 77, code: "+377", name: "MCO" },
  { id: 78, code: "+245", name: "GNB" },
  { id: 79, code: "+267", name: "BWA" },
  { id: 80, code: "+243", name: "COD" },
  { id: 81, code: "+253", name: "DJI" },
  { id: 82, code: "+240", name: "GNQ" },
  { id: 83, code: "+224", name: "GIN" },
  { id: 84, code: "+225", name: "CIV" },
  { id: 85, code: "+254", name: "KEN" },
  { id: 86, code: "+231", name: "LBR" },
  { id: 87, code: "+218", name: "LBY" },
  { id: 88, code: "+261", name: "MDG" },
  { id: 89, code: "+265", name: "MWI" },
  { id: 90, code: "+230", name: "MUS" },
  { id: 91, code: "+258", name: "MOZ" },
  { id: 92, code: "+227", name: "NER" },
  { id: 93, code: "+234", name: "NGA" },
  { id: 94, code: "+242", name: "COG" },
  { id: 95, code: "+262", name: "REU" },
  { id: 96, code: "+239", name: "STP" },
  { id: 97, code: "+221", name: "SEN" },
  { id: 98, code: "+248", name: "SYC" },
  { id: 99, code: "+232", name: "SLE" },
  { id: 100, code: "+252", name: "SOM" },
  { id: 101, code: "+27", name: "ZAF" },
  { id: 102, code: "+249", name: "SDN" },
  { id: 103, code: "+268", name: "SWZ" },
  { id: 104, code: "+255", name: "TZA" },
  { id: 105, code: "+228", name: "TGO" },
  { id: 106, code: "+216", name: "TUN" },
  { id: 107, code: "+256", name: "UGA" },
  { id: 108, code: "+260", name: "ZMB" },
];

export const countryCodes = countryCodeslist.sort((a, b) => {
  if (a.name < b.name)
    return -1;
  if (a.name > b.name)
    return 1;
  return 0;
})